<template>
  <div class="registration-form account-form">
    <validation-observer ref="createAccObs"
                         tag="form"
                         @submit.prevent="submitCreateAccountForm">
      <div class="form-fields">
        <base-v-input v-model.trim="emailInput"
                      id="email"
                      ref="email"
                      container-class="email-input"
                      name="email"
                      :submitted="createAccountSubmitted"
                      :label="$t('registration.emailLabel')"
                      rules="required|noSpaces|email"
                      vid="email">
        </base-v-input>
        <validate-password-dropdown :visible="passwordFieldFocused"
                                    :password="passwordInput">
          <base-v-input v-model.trim="passwordInput"
                        id="newPassword"
                        container-class="password-input"
                        name="newPassword"
                        rules="required|password"
                        @focus="passwordFieldFocused = true"
                        @blur="passwordFieldFocused = false"
                        :submitted="createAccountSubmitted"
                        :label="$t('registration.passwordLabel')"
                        revealPassword
                        type="password"
                        maxlength="20"
                        vid="password"
                        ref="password"/>
        </validate-password-dropdown>
        <base-v-input v-model.trim="confirmPasswordInput"
                      id="confirmPassword"
                      container-class="password-input"
                      name="confirmPassword"
                      rules="required|confirmPassword:@password"
                      :submitted="createAccountSubmitted"
                      :label="$t('registration.confirmPasswordLabel')"
                      revealPassword
                      type="password"
                      maxlength="20"
                      vid="confirmPassword"/>
        <base-checkbox v-model="acceptTerms" variant="green" class="create-acc-checkbox" required>
          {{ $t('registration.agreementTerms.line1') }} <a class="red-text" target="_blank" :href="consentLink">{{ $t('registration.agreementTerms.line2') }}</a>
        </base-checkbox>
      </div>
      <base-button :disabled="!createAccountFormFilled || buttonDisabled" :loading="dataLoading" class="account-btn"
                   type="submit">
        {{ $t('common.continue') }}
      </base-button>
    </validation-observer>
  </div>
</template>

<script>
import { lsGet } from '@/utils/localStorageController'
import { makeQueryString } from '@/utils/queryParser'
import ValidatePasswordDropdown from '@/components/common/validate-password-dropdown'
import { customRouter } from '@/customRouter'

export default {
  name: 'account-form',
  components: { ValidatePasswordDropdown },
  data () {
    return {
      acceptTerms: false,
      emailInput: '',
      passwordInput: '',
      confirmPasswordInput: '',
      token: '',
      createAccountSubmitted: false,
      buttonDisabled: false,
      dataLoading: false,
      passwordFieldFocused: false,
      consentLink: ''
    }
  },
  computed: {
    createAccountFormFilled () {
      return !!this.emailInput && !!this.passwordInput && !!this.acceptTerms
    }
  },
  methods: {
    async submitCreateAccountForm () {
      this.createAccountSubmitted = true
      const valid = await this.$refs.createAccObs.validate()
      if (valid) {
        // check if email already exists
        const qs = makeQueryString({ email: this.emailInput })
        this.$apiRequest.get(`register/isemailavailable${qs}`)
          .then(response => {
            if (response.data && response.data.emailExist) {
              this.$refs.createAccObs.setErrors({
                email: this.$t('errors.emailExists')
              })
            } else {
              this.sendApiRequest()
            }
          })
          .catch(e => {
            this.toast('error', {
              message: this.$t('errors.defaultError')
            })
          })
          .finally(() => {
            this.dataLoading = false
          })
      } else {
        this.dataLoading = false
      }
    },
    sendApiRequest () {
      this.dataLoading = true
      this.$apiRequest.post('register/form', { email: this.emailInput, newPassword: this.passwordInput, token: this.token })
        .then(response => {
          // handle continuation
          if (response.status === 200) {
            customRouter.goTo({ name: 'thankYouPage' })
          }
        })
        .catch(e => {
          if (e.response.data.errors && e.response.data.errors.length) {
            this.toast('error', {
              message: e.response.data.errors[0].message || this.$t('errors.defaultError')
            })
          } else {
            this.toast('error', {
              message: this.$t('errors.defaultError')
            })
          }
          this.dataLoading = false
        })
    },
    localStorageDataValid (data) {
      if (data && data.registered) {
        return data && data.token && data.email
      } else if (data && !data.registered) {
        return data && data.token
      }
    },
    fetchConsentLink () {
      this.$apiRequest.get('consenttemplates?consentTemplateId=GENERAL_TERMS_AGREEMENT')
        .then(response => {
          this.consentLink = response.data.description
        })
    }
  },
  mounted () {
    const registrationData = lsGet('sc_registration')

    if (this.localStorageDataValid(registrationData)) {
      this.email = registrationData.email
      this.token = registrationData.token
      this.fetchConsentLink()
      this.$emit('data-fetched', { email: registrationData.email, token: registrationData.token })
    } else {
      // if data in LS is not valid, return user to registration page
      customRouter.goTo({ name: 'registration' })
    }
  }

}
</script>

<style scoped lang="scss" src="./registration-comp-styles/registration-form.scss"></style>
